import moment from "moment";
import {
    ShipmentWeekRow,
    ShipmentYearRow,
    ShipmentsByDateRangeResponse,
    ShipmentsOverviewResponse,
} from "../../interfaces";
import { ShipmentsRepository } from "../repositories";

export class ShipmentsProcess {
    private shipmentsRepository: ShipmentsRepository;

    constructor() {
        this.shipmentsRepository = new ShipmentsRepository();
    }

    async getShipmentsByDateRange(
        startDate: string,
        endDate: string
    ): Promise<ShipmentsByDateRangeResponse> {
        const response = await this.shipmentsRepository.getShipmentsByDateRange(
            startDate,
            endDate
        );
        const raw: unknown[] = response.data?.data ?? [];
        const data: ShipmentWeekRow[] = raw.map((row: unknown) => {
            const r = row as Record<string, unknown>;
            const fechaKey =
                (r.fechaKey as string) ?? (r.fecha_key as string) ?? "";
            const fecha =
                (r.fecha as string) ||
                (fechaKey
                    ? moment(fechaKey).format("dddd, MMMM D, YYYY")
                    : "");
            return {
                fecha,
                fechaKey,
                ajustes: Number(r.ajustes ?? 0),
                nuevas: Number(r.nuevas ?? 0),
                reparaciones: Number(r.reparaciones ?? 0),
                reposiciones: Number(r.reposiciones ?? 0),
                sponsors: Number(r.sponsors ?? 0),
                referidos: Number(r.referidos ?? 0),
                totalBotas: Number(r.totalBotas ?? r.total_botas ?? 0),
            };
        });
        return { data };
    }

    async getShipmentsOverview(year: number): Promise<ShipmentsOverviewResponse> {
        const response = await this.shipmentsRepository.getShipmentsOverview(year);
        const raw: unknown[] = response.data?.data ?? [];
        const data: ShipmentYearRow[] = raw.map((row: unknown) => {
            const r = row as Record<string, unknown>;
            return {
                mes: String(r.mes ?? ""),
                ajustes: Number(r.ajustes ?? 0),
                nuevas: Number(r.nuevas ?? 0),
                reparaciones: Number(r.reparaciones ?? 0),
                reposiciones: Number(r.reposiciones ?? 0),
                sponsors: Number(r.sponsors ?? 0),
                referidos: Number(r.referidos ?? 0),
                totalBotas: Number(r.totalBotas ?? r.total_botas ?? 0),
            };
        });
        return { data };
    }
}
